import { formatKoreanPhoneNumberInput, normalizeKoreanPhoneDigits } from './phoneNumber';

export const normalizeNewOpportunityPhoneDigits = (value?: string | number | null) => {
    const digits = normalizeKoreanPhoneDigits(value);
    return digits.slice(0, 11);
};

export const formatNewOpportunityPhoneNumber = (value?: string | number | null) => {
    return formatKoreanPhoneNumberInput(value);
};

// reformat 후 cursor 위치를 "digit 인덱스" 기준으로 복원
// 010-1234-5678 같은 hyphen 자동 삽입 input에서 사용
export const calculateCursorAfterFormat = (
    oldValue: string,
    cursor: number,
    formattedValue: string,
): number => {
    const digitsBeforeCursor = (oldValue.slice(0, cursor).match(/\d/g) || []).length;
    if (digitsBeforeCursor === 0) return 0;
    let count = 0;
    for (let i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
            count++;
            if (count === digitsBeforeCursor) return i + 1;
        }
    }
    return formattedValue.length;
};
